export const thumbsUpEmojiId = '1f44d';

export const quickEmojiIds = [
	'1f44d', // thumbs up
	'1f44f', // clapping hands
	'1f525', // fire
	'2764', // heart
];
